import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs} from "../../../AbstractElements";
import ApplicationTable from "../../DataTables/Applications/ApplicationTable";

const InProcessApplicationsContainer = () => {
    const ApplStatus = "2,3,4,5,6";
    const Title = "Applications in Process";
    const Desc = "Displays all submitted applications that are currently under review. This module enables recruiters to evaluate applicant information, validate submitted documents, monitor recruitment progress, and complete the required actions for each stage of the hiring process.";
    return (
        <>
        <Breadcrumbs mainTitle="In Process" parent="Application Forms" />
        <Container fluid>
            <Row>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <ApplicationTable 
                            ApplStatus={ApplStatus} 
                            Title={Title} 
                            Desc={Desc}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        </>
    );
};

export default InProcessApplicationsContainer;
